module.exports = __webpack_public_path__ + "img/team.de8ed0c2.jpg";